import { get } from '.';

export function GetBigBoardOrganizationAgentCounts() {
	return get<any>("/app/api/big_board_dashboard/agents");
}

export function GetBaseDashboardSummaries() {
	return get<any>("/app/api/big_board_dashboard/summaries");
}
